import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import { getTemplateDetail, submitLogoShowcase, getLogoShowcaseDetail, updateLogoShowcase, deleteLogoShowcase } from "../../../utils/logoShowcaseApi";
//import ColorPicker from "../../../components/ColorPicker";

const ContentTab = ({ isTemplateId, setTemplateId, widgetName, template_name, template_image, layout_name,layout_type, updateLogoShowcaseTabData, logoShowcaseTabData,setRefreshWidgetList }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [apiLogoShowcase, setApiLogoShowcase] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = useRef([]);
    const [isSubmitLogoShowcase, setIsSubmitLogoShowcase] = useState(false); 
    const location = useLocation();
    const isEditPage = location.pathname.startsWith("/customer/edit/logo-showcase/");
    const { uuid } = useParams();
    const templateId = isEditPage && uuid ? uuid : isTemplateId || "";
    const [apiSingleLogoShowcase, setApiSingleLogoShowcase] = useState(null);
    const [logoShowcaseId, setLogoShowcaseId] = useState(null);

    //Logo Details
    const imageInputRef = useRef(null);
    const [logoSize, setLogoSize] = useState("50px");
    const [editLogoSize, setEditLogoSize] = useState("50px");
    const [link, setLink] = useState("");
    const [caption, setCaption] = useState("");
    const [isShowHeader, setIsShowHeader] = useState(Number(logoShowcaseTabData.is_show_header));
    const [headerTitle, setHeaderTitle] = useState(logoShowcaseTabData.header_title);
    const [headerCaption, setHeaderCaption] = useState(logoShowcaseTabData.header_caption);
    const [isShowActionButton, setIsShowActionButton] = useState(Number(logoShowcaseTabData.is_show_action_button));
    const [actionLink, setActionLink] = useState(logoShowcaseTabData.action_link);
    const [actionText, setActionText] = useState(logoShowcaseTabData.action_text);

    // Handlers QR Code Change
    const handleLogoSizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 1;
        const MAX_SIZE = 100;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setLogoSize(valueWithPx); 
    };

    //Handlers Show Header Change
    const handleShowHeaderChange = (e) => {
        const checked = e.target.checked;
        setIsShowHeader(checked);
        updateLogoShowcaseTabData("is_show_header", checked); 
    };

    //Handlers Header Title Change
    const handleHeaderTitleChange = (e) => {
        const value = e.target.value;
        setHeaderTitle(value);
        updateLogoShowcaseTabData("header_title", value); 
    };

    //Handlers Show Header Caption Change
    const handleHeaderCaptionChange = (e) => {
        const value = e.target.value;
        setHeaderCaption(value);
        updateLogoShowcaseTabData("header_caption", value); 
    };

    //Handlers Show Action Button Change
    const handleShowActionButtonChange = (e) => {
        const checked = e.target.checked;
        setIsShowActionButton(checked);
        updateLogoShowcaseTabData("is_show_action_button", checked); 
    };

    //Handlers Action LInk Title Change
    const handleActionLinkChange = (e) => {
        const value = e.target.value;
        setActionLink(value);
        updateLogoShowcaseTabData("action_link", value); 
    };

    //Handlers Show  Action Text Change
    const handleActionTextChange = (e) => {
        const value = e.target.value;
        setActionText(value);
        updateLogoShowcaseTabData("action_text", value); 
    };

    //Wrap fetchTemplateDetails in useCallback to prevent re-creation on every render
    const fetchTemplateDetails = useCallback(async () => {
        if (!templateId) return;

        setIsLoading(true);
        try {
            const templateResult = await getTemplateDetail(templateId);
            if (templateResult?.status === true && Array.isArray(templateResult?.data?.data_list)) {
                if (templateResult?.status === true && templateResult?.data?.data_list) {
                    setApiLogoShowcase(templateResult.data.data_list);
                } else {
                    setApiLogoShowcase([]);
                }
            } else {
                setApiLogoShowcase([]);
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [templateId]);

    // Fix useEffect by including fetchTemplateDetails
    useEffect(() => {
        fetchTemplateDetails();
    }, [fetchTemplateDetails]);

    // Also include fetchTemplateDetails in this useEffect
    useEffect(() => {
        if (isEditPage) {
            if (isEditPage && uuid) {
                setTemplateId(uuid);
            } else if (isTemplateId) {
                setTemplateId(isTemplateId);
            }
        }
        fetchTemplateDetails();
    }, [isEditPage, uuid, setTemplateId, isTemplateId, fetchTemplateDetails]);

    // Toggle dropdown visibility
    const toggleDropdown = (index) => {
        setOpenDropdown((prev) => (prev === index ? null : index));
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                openDropdown !== null &&
                dropdownRefs.current[openDropdown] &&
                !dropdownRefs.current[openDropdown].contains(event.target) &&
                !event.target.closest(".inner-dropdown-menu")
            ) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);

    //Submit Logo Showcase Handler
    const handleSubmitLogoShowcase = async (e) => {
        e.preventDefault();
    
        try {
            setIsSubmitLogoShowcase(true);
    
            const formData = new FormData();

            // Check if template_id is already exists 
            if (templateId) {
                formData.append("template_id", templateId);
            }

            //Pass Logo detail
            formData.append("image", e.target.image?.files[0] || '');
            formData.append("logo_size", logoSize);
            formData.append("logo_link", link);
            formData.append("logo_caption", caption);
            formData.append("type", "Dynamic");

            // Check if template_id is not exists 
            if (!templateId) {
                formData.append("widget_name", widgetName);
                formData.append("template_name", template_name);
                formData.append("template_image", template_image);
                formData.append("layout_name", layout_name);
                formData.append("layout_type", layout_type);
            }
    
            //Submit API
            const response = await submitLogoShowcase(formData);
            if (response.status) { 
                toast.success(response.message);
                // Save templateId after first creation
                if (response.template_id) {
                   setTemplateId(response.template_id); 
                }

                // Reset form fields
                if (imageInputRef.current) {
                    imageInputRef.current.value = ""; 
                }
                setLink("");
                setCaption("");

                await fetchTemplateDetails();
                setActiveSettingElementsTab("main");

                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitLogoShowcase(false);
        }
    };    

    // Handle Edit Click 
    const handleEditLogoShowcase = (data) => {
        setOpenDropdown(null);
        setLogoShowcaseId(data.id);
        setActiveSettingElementsTab("edit_logo_showcase");
        fetchLogoShowcaseDetails(data.id);
    };

    // Handlers Edit Logo Size Change
    const handleEditLogoSizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 1;
        const MAX_SIZE = 100;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setEditLogoSize(valueWithPx); 
    };

    // Handle Delete Click
    const handleDeleteLogoShowcase = async (data) => {
        setOpenDropdown(null);

        try {
            // Prepare the payload
            const payload = {
                logo_showcase_id: data.id,
            };

            // API Call
            const api_response = await deleteLogoShowcase(payload);
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);

                // Refresh testimonials
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    // Wrap fetchLogoShowcaseDetails in useCallback to prevent re-creation on every render
    const fetchLogoShowcaseDetails = useCallback(async (logoShowcaseId) => {
        if (!logoShowcaseId) return;

        setIsLoading(true); 
        try {
            const templateResult = await getLogoShowcaseDetail(logoShowcaseId); 
            if (templateResult?.status === true && templateResult?.data) {
                setApiSingleLogoShowcase(templateResult.data);
                setEditLogoSize(templateResult.data.logo_size); 
            } else { 
                setApiSingleLogoShowcase(null);
            }
        } catch (error) {
            //console.error("Error fetching:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    //Update Logo Showcase Handler
    const handleUpdateLogoShowcase = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitLogoShowcase(true);
            setOpenDropdown(null);
            // Create FormData object
            const formData = new FormData();
            formData.append("id", logoShowcaseId);
            formData.append("image", e.target.image?.files[0] || '');
            formData.append("logo_size", editLogoSize);
            formData.append("logo_link", e.target.logo_link?.value || '');
            formData.append("logo_caption", e.target.logo_caption?.value || '');

            //Api Call
            const response = await updateLogoShowcase(formData);

            if (response.status) {
                toast.success(response.message);

                //Refresh Logo Showcase
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);

                // Switch back to the main view
                setActiveSettingElementsTab("main");
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitLogoShowcase(false);
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Content</span>
                    <div className="side-baar-box-header">
                        <div className="add-testimonal-button">
                            <button onClick={() => setActiveSettingElementsTab("add_logo_showcase")}>+ Add Logos</button>
                        </div>
                        <div className="testimonal-side-baar-list">
                            {Array.isArray(apiLogoShowcase) && apiLogoShowcase.length > 0 ? (
                                <ul>
                                    {apiLogoShowcase.map((data, index) => (
                                        <li key={index} className="testimonial-item">
                                            <button type="button" className="testimonial-item-button" onClick={() => handleEditLogoShowcase(data)}>
                                                <div className="list-image-testimonal">
                                                    <img src={data.logo} alt={data.image_name} />
                                                </div>
                                                <div className="list-text-testimonal">  
                                                    <span>{data.logo_caption}</span> 
                                                </div>
                                            </button>
                                            <div className="list-button-testimonal" ref={(el) => (dropdownRefs.current[index] = el)}>
                                                <button onClick={() => toggleDropdown(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3.864 8.333a1.363 1.363 0 1 1 0 2.726 1.363 1.363 0 0 1 0-2.726Zm6.136 0a1.363 1.363 0 1 1 .001 2.726A1.363 1.363 0 0 1 10 8.333Zm6.136 0a1.363 1.363 0 1 1 .001 2.726 1.363 1.363 0 0 1 0-2.726Z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                            {openDropdown === index && (
                                                <div className="inner-dropdown-menu">
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleEditLogoShowcase(data)}>Edit</button>
                                                    </div>
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleDeleteLogoShowcase(data)}> Delete</button>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="customize-elements-list">
                            <ul>
                                <li>
                                    <button onClick={() => setActiveSettingElementsTab("header")}>Header<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                                </li>
                                <li>
                                    <button onClick={() => setActiveSettingElementsTab("call_to_action_button")}>Call to Action Button<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "add_logo_showcase" && (
                <>
                    <div className="inner-box-layout">
                        <form onSubmit={handleSubmitLogoShowcase}>
                            <span>
                                <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                                </button>
                                Add Logos
                                
                            </span>

                            {/* <div className="name-tile-row">Logo Detail</div> */}
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Icon</span>
                                    <input type="file" name="image" accept="image/*" ref={imageInputRef} />
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <span>Custom Logo Size</span>
                                    <em>{parseInt(logoSize)}px</em>
                                    <div className="slider-container">
                                        <input
                                            type="range"
                                            min="1"
                                            max="100"
                                            value={parseInt(logoSize)}
                                            onChange={handleLogoSizeChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="box-header-row bubble-text border-0">
                                <span>Link</span>
                                <input name="link" value={link} type="text" onChange={(e) => setLink(e.target.value)} />
                            </div>
                            <div className="box-header-row bubble-text pt-0 border-0">
                                <span>Caption</span>
                                <input name="caption" value={caption} type="text" onChange={(e) => setCaption(e.target.value)} />
                            </div>
                            <div className="customize-button">
                                <button type="submit" className="float-none text-black bg-white" disabled={isSubmitLogoShowcase}>
                                    {isSubmitLogoShowcase ? "Submitting..." : "Done"}
                                </button>
                            </div>
                        </form>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "edit_logo_showcase" && (
                <div className="inner-box-layout">
                    {isLoading ? (
                        <div className="inner-loader-container">
                            <div className="inner-spinner"></div>
                            <p>Loading, please wait...</p>
                        </div>
                    ) : apiSingleLogoShowcase ? (
                        <>
                        <form onSubmit={handleUpdateLogoShowcase}>
                            <span>
                                <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                                </button>
                                Edit Logo Detail
                                <button type="submit" className="button-color button-done" disabled={isSubmitLogoShowcase}>
                                    {isSubmitLogoShowcase ? "Updating..." : "Update"}
                                </button>
                            </span>

                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Icon</span>
                                    <input type="file" name="image" accept="image/*" />
                                    {apiSingleLogoShowcase.logo && (
                                        <img src={apiSingleLogoShowcase.logo} alt={apiSingleLogoShowcase.image_name} width="50" height="50" />
                                    )}
                                </div>
                            </div>

                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <span>Custom Logo Size</span>
                                    <em>{parseInt(editLogoSize)}px</em>
                                    <div className="slider-container">
                                        <input 
                                            name="logo_size"
                                            type="range"
                                            min="1"
                                            max="100"
                                            value={parseInt(editLogoSize)}
                                            onChange={handleEditLogoSizeChange}
                                        />
                                    </div>
                                </div>
                                <div className="box-header-row bubble-text">
                                    <span>Link</span>
                                    <input name="logo_link" value={apiSingleLogoShowcase.logo_link || ""}
                                        onChange={(e) => setApiSingleLogoShowcase({ ...apiSingleLogoShowcase, logo_link: e.target.value })} type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <span>Caption</span>
                                    <input name="logo_caption" value={apiSingleLogoShowcase.logo_caption || ""}
                                        onChange={(e) => setApiSingleLogoShowcase({ ...apiSingleLogoShowcase, logo_caption: e.target.value })} type="text" />
                                </div>
                            </div>
                        </form>
                        </>
                    ) : (
                        <p>No logo showcase details. Please try again.</p>
                    )}
                </div>
            )}

            {activeSettingElementsTab === "header" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Header</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                               <span>Header</span>
                                <div className="form-group">
                                    <input id="open_is_show_header" className="chkbx-toggle" type="checkbox" checked={isShowHeader} onChange={handleShowHeaderChange} />
                                    <label for="open_is_show_header"></label>
                                </div>
                            </div>
                            {Number(logoShowcaseTabData.is_show_header) === 1 && (
                            <>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Title</label>
                                    <input value={headerTitle} onChange={handleHeaderTitleChange} placeholder="" type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Caption</label>
                                    <textarea className="w-100" value={headerCaption} onChange={handleHeaderCaptionChange} placeholder="" defaultValue=""></textarea>
                                </div>
                            </>
                            )}
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "call_to_action_button" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Call to Action Button</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                               <span>Show Button</span>
                                <div className="form-group">
                                    <input id="open_is_show_button" className="chkbx-toggle" type="checkbox" checked={isShowActionButton} onChange={handleShowActionButtonChange} />
                                    <label for="open_is_show_button"></label>
                                </div>
                            </div>
                            
                            {Number(logoShowcaseTabData.is_show_action_button) === 1 && (
                                <>
                                    <div className="box-header-row bubble-text">
                                        <label className="mb-1">Link</label>
                                        <input value={actionLink} onChange={handleActionLinkChange} placeholder="" type="text" />
                                    </div>
                                    <div className="box-header-row bubble-text">
                                        <label className="mb-1"> Text</label>
                                        <input value={actionText} onChange={handleActionTextChange} placeholder="" type="text" />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ContentTab;